module.exports = __webpack_public_path__ + "img/top-view-colorful-pills.0ca44f91.jpeg";